var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 11.0254C26.9798 5.4814 21.1586 1 13.9976 1C6.8366 1 1 5.4814 1 11.0254C1 15.6454 4.9424 19.4338 10.3478 20.635L11.0562 24.5774C11.0824 24.7313 11.1521 24.8744 11.2572 24.9899C11.3623 25.1053 11.4982 25.1882 11.649 25.2287C11.7997 25.2693 11.9589 25.2657 12.1077 25.2185C12.2565 25.1713 12.3886 25.0824 12.4884 24.9624L15.8456 21.02C22.1288 20.2346 26.9798 16.0766 26.9798 11.0254Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3932 15.8149C29.1662 16.6773 31.7996 19.3107 31.7996 22.2983C31.7996 25.2859 29.1662 27.9039 25.6396 28.7201L25.1622 31.3535C25.1452 31.4566 25.0986 31.5525 25.0281 31.6296C24.9576 31.7067 24.8662 31.7617 24.765 31.7878C24.6639 31.8139 24.5573 31.81 24.4583 31.7767C24.3593 31.7433 24.2721 31.6819 24.2074 31.5999L21.9744 28.9203C18.0936 28.4891 14.9058 25.8403 14.5208 22.6063",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.855996b6bf4a435bd90c53586aaa43c1.svg";
export { ForwardRef as ReactComponent };